module.exports = __webpack_public_path__ + "static/media/preset_original.9f4c7ea5.jpg";